<template>
  <img
    ref="img"
    :srcset="srcset"
    :sizes="sizes"
    :src="image.url"
    :alt="image.file"
  />
</template>

<script>
import { maxWidth, widthToMediaQuery } from "@utils/tailwind";
// I MADE THE BUCKET PUBLIC https://cloud.google.com/storage/docs/access-control/making-data-public?authuser=1
// AWAITING ON CACHED URLs FROM FLAMELINK!

// Format [[breakpoint-string, divider], viewport-string]
export const sizesHelper = sizesArray =>
  sizesArray
    .map(size => {
      if (typeof size === "string") return size;

      return `${widthToMediaQuery(parseInt(maxWidth(size[0])))} ${parseInt(
        maxWidth(size[0])
      ) / size[1]}px`;
    })
    .join(", ");

export default {
  name: "CoreImage",

  props: {
    image: {
      type: Object
    },
    sizes: {
      type: String,
      default: "100vw"
    }
  },

  computed: {
    srcset() {
      // Fix's bug when sizes key is not present
      if (typeof this.image.sizes === "undefined") {
        return "";
      }

      const srcset = this.image.sizes.map(
        size =>
          `https://storage.googleapis.com/flore-directory.appspot.com/${encodeURI(
            `flamelink/media/sized/${size.path}/${this.image.file}`
          )} ${size.width}w`
      );

      return srcset.join(", ");
    }
  },

  watch: {
    image: {
      immediate: true,
      async handler() {
        await this.$nextTick();

        this.setLoad();
      }
    }
  },

  methods: {
    setLoad() {
      const { img } = this.$refs;

      if (img.complete) this.loaded();
      else img.addEventListener("load", this.loaded);
    },
    loaded() {
      if (typeof this.$refs.img !== "undefined") {
        this.$refs.img.removeEventListener("load", this.loaded);
      }
      this.$emit("load");
    }
  }
};
</script>
